import { useEffect, useMemo, useState } from 'react';

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const usePagination = (items, pageSize = 10) => {
  const safeItems = Array.isArray(items) ? items : [];
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(safeItems.length / pageSize));

  useEffect(() => {
    setPage((current) => clamp(current, 1, totalPages));
  }, [totalPages]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    return safeItems.slice(start, end);
  }, [safeItems, page, pageSize]);

  return {
    page,
    setPage,
    totalPages,
    pageItems,
    pageSize,
    totalItems: safeItems.length
  };
};

export default usePagination;
